/** TakeNotes logo B mark (note page + waveform). Used for favicon / sidebar / compact UI. */
const MARK_SRC = '/logo/takenotes-logo-b-mark.svg';

export function TnMark({ size = 'sm' }: { size?: 'sm' | 'lg' }): JSX.Element {
  return (
    <img
      className={size === 'lg' ? 'tn-mark tn-mark--lg' : 'tn-mark'}
      src={MARK_SRC}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}

/**
 * Locked TakeNotes lockup (George 2026-10-06): mark B + Inter Bold wordmark,
 * "Take" #111827 · "Notes" #4F6EF7, accent underline under Notes only.
 * In-app brand uses takenotes-logo-locked.png (no URL). The -url variant is for the Zoom bot tile only.
 */
const LOCKUP_SRC = '/logo/takenotes-logo-locked.png';

export function TnWordmark(
  { className, size = 'lg' }: { className?: string; size?: 'header' | 'lg' } = {},
): JSX.Element {
  const cls = ['tn-lockup', `tn-lockup--${size}`, className].filter(Boolean).join(' ');
  return <img className={cls} src={LOCKUP_SRC} alt="TakeNotes" draggable={false} />;
}
